import styled from 'styled-components';
import WhatsAppSvg from '../../assets/mytrips/whatsapp.svg';

const WhatsAppIcon = styled(WhatsAppSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.8rem'};
  height: ${props => props.height || '1.9rem'};
  margin: ${props => props.margin};
`;

export default WhatsAppIcon;
